import Footer from 'v3/shared/components/Footer';
import { OnlineNavBar } from 'v3/shared/components/OnlineNavBar';
import { IDefaultTemplate } from 'v3/shared/templates/OnlineCommomTemplate/types';
import { TemplateBody, TemplateContainer } from 'v3/shared/templates/styles';

export const OnlineCommonTemplate: React.FC<IDefaultTemplate> = ({ children }) => {
  return (
    <TemplateContainer>
      <OnlineNavBar />
      <TemplateBody>{children}</TemplateBody>
      <Footer />
    </TemplateContainer>
  );
};
